class IdleTimer {
  constructor({ timeout, onTimeOut }) {
    this.timeout = timeout;
    this.onTimeOut = onTimeOut;
    this.expiredTime = Date.now() + (this.timeout * 1000);
    this.updateExpireTime = this.updateExpireTime.bind(this);
    this.startInterval = this.startInterval.bind(this);
    this.tracker = this.tracker.bind(this);
    this.cleanUp = this.cleanUp.bind(this);
    this.tracker();
    this.startInterval();
  }

  updateExpireTime = () => {
    this.expiredTime = Date.now() + (this.timeout * 1000);
  }

  startInterval = () => {
    this.updateExpireTime();
    this.interval = setInterval(() => {
      if (this.expiredTime < Date.now()) {
        if (this.onTimeOut) {
          this.onTimeOut();
        }
      }
    }, 1000);
  }

  tracker = () => {
    if (typeof window !== 'undefined') {
      window.addEventListener('mousemove', this.updateExpireTime);
      window.addEventListener('scroll', this.updateExpireTime);
      window.addEventListener('keydown', this.updateExpireTime);
    }
  }

  cleanUp = () => {
    if (typeof window !== 'undefined') {
      clearInterval(this.interval);
      window.removeEventListener('mousemove', this.updateExpireTime);
      window.removeEventListener('scroll', this.updateExpireTime);
      window.removeEventListener('keydown', this.updateExpireTime);
    }
  }
}

export const timeoutPreset = {
  mobileModal: 120,
};

export default IdleTimer;
